import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import './BusinessNewPassword.css';
import Topbar from "../../BusinessTopbar";
import Footer from "../../BusinessFooter";
import Image from 'react-bootstrap/Image';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import loader from '../../../assests/loader.gif';
import {validatefogpass} from '../../../Utils/validate';
import API from '../../../Utils/Api';
import { gettoastwarning,gettoastsuccess } from '../../../Utils/Common';

const BusinessNewPassword = () => {
	const [loading,setLoading] = useState(false);

	const [errors,setErrors] = useState({});

  	const [inputs,setInputs] = useState({newPassword:'',confirmPassword:''});

	useEffect(() => {
		document.title = `Business New Password | Local Bells`;
		document.getElementById('bodywrap').className = 'bunp';

		if (localStorage.getItem('email') !== null && localStorage.getItem('otp') !== null) {
			
		}else
		{		
			window.location.href = "/business/forgot-password";
		}

	}, []);
	
	const [showPassword, setShowPassword] = useState(false);
	const togglePassword = () => {
		setShowPassword(prevState => !prevState);
	};
	const [showConfPassword, setShowConfPassword] = useState(false);
	const toggleConfPassword = () => {
		setShowConfPassword(prevState => !prevState);
	};
	/* Start Value set */
	const handleInputChange = (event) => {
	  event.persist();
	  setInputs(inputs => ({...inputs, [event.target.name]: event.target.value}));       
	}
	/* End Value set */
	const handleSubmit = (e) => {
		e.preventDefault();
		const validationErrors = validatefogpass(inputs);
		  const noErrors = Object.keys(validationErrors).length === 0;
		  setErrors({});
		  setErrors(validationErrors);
		  if(noErrors){
			setLoading(true); 
		  	let newPassword=inputs.newPassword;
		    let email=localStorage.getItem('email');
		    let otp=localStorage.getItem('otp');
		    const otp1 = otp.replace(/,/g, '');
		    let formData = new FormData(); 
		      formData.append('email', email);
		      formData.append('type', 2);
		      formData.append('code', otp1);
		      formData.append('newPassword', newPassword);
		      API.post('reset_password_update', formData)
		        .then(response => {
		          setLoading(false); 
		        if(response.data.status === false){
		          setLoading(false); 
		          gettoastwarning(response.data.message,'');
		        }else{
		          localStorage.removeItem("otp");
		          localStorage.removeItem("email");
		           //navigate('/login');
		           gettoastsuccess(response.data.message,'/business/login');
		        }                  
		      }).catch(error => {
		         setLoading(false);
		          gettoastwarning("Something went wrong. Please try again later.",'');
		      });
		 }
	};


	return (
		<>
			<Topbar />
			<section className='signup-main'>
				<Container>
					<Row className='justify-content-center'>
						<Col md={8} lg={5} xs={12}>
							<div className="signup-form-box">
								<div className='sfb-title mb-5'>
									<h2><span>New Password</span></h2>
									<h5>Enter your new password</h5>
								</div>
								<Form onSubmit={handleSubmit}>

									<InputGroup className="">
										<Form.Control
											placeholder="New Password"
											aria-label="password"
											aria-describedby="basic-addon1"
											type={showPassword ? 'text' : 'password'}
											name="newPassword"
                        					onChange={handleInputChange}
										/>
										<InputGroup.Text id="basic-addon1" onClick={togglePassword}>
											{/*<Image src={showPassword ? '../assets/images/show.webp' : '../assets/images/hide.webp'} className="img-fluid" alt={showPassword ? 'hide' : 'show'} />*/}
											<Image
											  src={
											    showPassword
											      ? process.env.REACT_APP_BASE_URL + 'assets/images/show.webp'
											      : process.env.REACT_APP_BASE_URL + 'assets/images/hide.webp'
											  }
											  className="img-fluid"
											  alt={showPassword ? 'hide' : 'show'}
											/>
										</InputGroup.Text>
									</InputGroup>
									{errors.newPassword && (<p className="text-danger">{errors.newPassword}</p>)}
									<InputGroup className="">
										<Form.Control
											placeholder="Confirm Password"
											aria-label="password"
											aria-describedby="basic-addon1"
											type={showConfPassword ? 'text' : 'password'}
											name="confirmPassword"
                    						onChange={handleInputChange}
										/>
										<InputGroup.Text id="confpassword" onClick={toggleConfPassword}>
											{/*<Image src={showConfPassword ? '../assets/images/show.webp' : '../assets/images/hide.webp'} className="img-fluid" alt={showConfPassword ? 'hide' : 'show'} />*/}
											<Image
											  src={
											    showConfPassword
											      ? process.env.REACT_APP_BASE_URL + 'assets/images/show.webp'
											      : process.env.REACT_APP_BASE_URL + 'assets/images/hide.webp'
											  }
											  className="img-fluid"
											  alt={showConfPassword ? 'hide' : 'show'}
											/>
										</InputGroup.Text>
									</InputGroup>
									{errors.confirmPassword && (<p className="text-danger">{errors.confirmPassword}</p>)}

									<Button variant="primary" type="submit" className='blue-btn'>
										<h6>Submit</h6>
									</Button>
								</Form>

							</div>
						</Col>
					</Row>
				</Container>
			</section>
			<Footer />
			{loading && (
	         <div className="loadingClass">
	          <img src={loader} alt="loader"/>
	        </div>
	         )}
		</>
	)
}

export default BusinessNewPassword;


